

import {
  Users,
  Globe,
  Ban,
  DollarSign,
  BarChart2,
  Wrench,
  Send,
  Clock,
  History,
  Cog,
  MoreHorizontal,
  Bell,
  Shield,
  FileText,
  HelpCircle,
  Settings,
  Webhook,
  Map,
  Workflow
} from "lucide-react";
import { Button } from '@/src/components/ui/shadcn/button';
import Link from "next/link";

export const moreItems = [
  {
    name: "Users Management",
    icon: <Users className="w-4 h-4" />,
    path: "/users",
    description: "Add or edit users and permissions to your account."
  },
  {
    name: "Global - Domains",
    icon: <Globe className="w-4 h-4" />,
    path: "/domains",
    description: "Add and edit all your domains in one place."
  },
  {
    name: "Blocked Traffic Rules",
    icon: <Ban className="w-4 h-4" />,
    path: "/dashboard/blocked-traffic",
    description: "Set and edit your specific rules on different traffic sources."
  },
  {
    name: "Cost Update",
    icon: <DollarSign className="w-4 h-4" />,
    path: "/cost-update",
    description: "All settings controlling cost to individual and grouped campaigns."
  },
  {
    name: "Conversions Update",
    icon: <BarChart2 className="w-4 h-4" />,
    path: "/conversions",
    description: "Set and adjust rules to your conversions filters on campaigns."
  },
  {
    name: "Pixels",
    icon: <Wrench className="w-4 h-4" />,
    path: "/pixels",
    description: "Add pixel settings for tracking landing pages and campaigns."
  },
  {
    name: "Tokens Manager",
    icon: <Send className="w-4 h-4" />,
    path: "/tokens",
    description: "Add or edit tokens and rules"
  },
  {
    name: "Integrations",
    icon: <Cog className="w-4 h-4" />,
    path: "/integrations",
    description: "Seamlessly integrate third party scripts like Google Analytics, Facebook Pixel, and more with Clickster Integrations."
  },
  {
    name: "Automated Process Logs",
    icon: <Clock className="w-4 h-4" />,
    path: "/process-logs",
    description: "Review logs for all automated processes like Cost Update, Conversion Update and more"
  },
  {
    name: "Road Map",
    icon: <Map className="w-4 h-4" />,
    path: "/roadmap",
    description: "View our product roadmap and upcoming features."
  },
  {
    name: "Workflows",
    icon: <Workflow className="w-4 h-4" />,
    path: "/workflows",
    description: "Create and manage automated workflows."
  }
];

export const collapsedMoreItems = [
  {
    name: "Change Log",
    icon: <Clock className="w-4 h-4" />,
    path: "/change-log",
    description: "Here you can see the logs."
  },
  {
    name: "Clickster Version",
    icon: <History className="w-4 h-4" />,
    path: "/version",
    description: "See all notable changes made to a Clickster this includes records of changes such as bug fixes, new features, etc."
  },
  {
    name: "Notifications",
    icon: <Bell className="w-4 h-4" />,
    path: "/notifications",
    description: "Configure email and in-app notification preferences."
  },
  {
    name: "Security",
    icon: <Shield className="w-4 h-4" />,
    path: "/security",
    description: "Manage 2FA, API keys, and security settings."
  },
  {
    name: "Knowledge",
    icon: <FileText className="w-4 h-4" />,
    path: "/knowledge",
    description: "Access guides, API docs, and integration tutorials."
  },
  {
    name: "Support",
    icon: <HelpCircle className="w-4 h-4" />,
    path: "/support",
    description: "Get help from our support team and tracking documentation."
  },
  {
    name: "Account Settings",
    icon: <Settings className="w-4 h-4" />,
    path: "/settings",
    description: "Manage your account preferences and billing information."
  },
  {
    name: "Webhooks",
    icon: <Webhook className="w-4 h-4" />,
    path: "/webhooks",
    description: "Configure and manage webhook integrations."
  }
];

export function MoreDropdown() {
  return (
    <Button
      variant="ghost"
      className="w-full justify-start"
      asChild
    >
      <Link href="/more">
        <MoreHorizontal className="w-5 h-5 mr-2" />
        More
      </Link>
    </Button>
  );
}